
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

const AboutHero = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="text-center px-4 md:px-0 mb-12 md:mb-16">
      <h1 className={`${isMobile ? 'text-3xl' : 'text-4xl md:text-5xl'} font-serif font-semibold text-patrimoine-dark mb-4`}>
        À Propos de Nous
      </h1>
      <div className="w-24 h-1 bg-patrimoine-gold mx-auto mb-6 md:mb-8"></div>
      <p className={`${isMobile ? 'text-base' : 'text-lg md:text-xl'} text-patrimoine-muted max-w-3xl mx-auto`}>
        Chez LA PATRIMONIALE, nous accompagnons nos clients avec expertise et dévouement dans la gestion et l'optimisation de leur patrimoine.
      </p>
    </div>
  );
};

export default AboutHero;
